import {injectReducer} from '../../store/reducers'
import {isLoggedIn} from '../../utils/auth'

export default (store) => ({
  path: 'form-response-analytics',
  onEnter: isLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const FormResponseAnalyticsContainer = require('./containers/FormResponseAnalytics').default;
      const reducer = require('./modules/formResponseAnalytics').reducer;
      let homeReducers = require('../Home/modules/home');

      /*  Add the reducer to the store on key 'counter'  */
      const loadStoreOptionsReducer = homeReducers.loadStoreOptionsReducer;
      const filterValuesReducer = homeReducers.filterValuesReducer;
      injectReducer(store, {key: 'formResponseAnalytics', reducer: reducer});
      injectReducer(store, {key: 'storeOptions', reducer: loadStoreOptionsReducer});
      injectReducer(store, {key: 'filter', reducer: filterValuesReducer});
      /*  Return getComponent   */
      cb(null, FormResponseAnalyticsContainer)

      /* Webpack named bundle   */
    }, 'formResponseAnalytics')
  }
})



// WEBPACK FOOTER //
// ./src/routes/FormResponseAnalytics/index.js